import React from 'react';
import '../../css/slider_flota.css'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
};

const ImageSlider = ({images}) => {

  return (
    <div className='fleetserices_img'>
        <div className="slider-flota">
            <Slider {...settings}>
                {images.map((slide, index) => (
                    <div key={index} className='destino_slider_container'>
                        <img src={slide.image} alt={`Slide ${index + 1}`} />                        
                    </div>
                ))}
            </Slider>
        </div>
    </div>
   
  );
};

export default ImageSlider;


